export default __webpack_public_path__ + "static/media/rewfa.3cba56e3.png";